import React, { useEffect, useState } from "react";

import Layout from "@/components/Layout";

import withAuthentication from "@/components/withAuthentication";

import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getSession } from "next-auth/client";
import { useTranslation } from "next-i18next";
import { OfficeType } from "@/types/office";
import Cloud from "@/components/Cloud";
import { useRouter } from "next/router";
import axios from "axios";

export const CloudPage = (): React.ReactElement => {
  const { t } = useTranslation("common");
  const [folder, setFolder] = useState();
  const [breadcrumb, setBreadcrumb] = useState([
    { label: t("cloud.cloud"), href: "/cloud" },
  ]);
  const router = useRouter();
  const { folders } = router.query;

  useEffect(() => {
    axios
      .post("/cloud/dir", { folders })
      .then((res) => setFolder(res.data))
      .catch(() => router.push("/cloud"));
  }, [folders]);

  useEffect(() => {
    const newBreadcrumb =
      folder?.prevFolders?.slice(1)?.reduce(
        (acc, folder) => [
          ...acc,
          {
            label: folder?.name,
            href: `${acc[acc?.length - 1]?.href}/${folder?.slug}`,
          },
        ],
        [{ label: t("cloud.cloud"), href: "/cloud" }]
      ) || [];

    setBreadcrumb([
      ...newBreadcrumb,
      { label: folder?.name, isCurrentPage: true },
    ]);
  }, [folder]);

  return (
    <Layout title={t("cloud.cloud")} breadcrumb={breadcrumb}>
      <Cloud folderId={folder?.id} />
    </Layout>
  );
};

export const getServerSideProps = async (ctx) => ({
  props: {
    ...(await serverSideTranslations(ctx.locale, ["common"])),
    session: await getSession(ctx),
  },
});

export default withAuthentication(CloudPage, OfficeType.PRESS);
